/**
 * DevExtreme (esm/__internal/scheduler/r1/components/base/all_day_panel_cell.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { createComponentVNode } from "inferno";
import { BaseInfernoComponent } from "../../../../core/r1/runtime/inferno/index";
import { ALL_DAY_PANEL_CELL_CLASS } from "../const";
import { DateTableCallBaseDefaultProps, DateTableCellBase } from "./date_table_cell_base";
export let AllDayPanelCell = /*#__PURE__*/(() => {
  class AllDayPanelCell extends BaseInfernoComponent {
    render() {
      const {
        className: className,
        viewContext: viewContext,
        dataCellTemplate: dataCellTemplate,
        endDate: endDate,
        groupIndex: groupIndex,
        groups: groups,
        index: index,
        isFirstGroupCell: isFirstGroupCell,
        isFocused: isFocused,
        isLastGroupCell: isLastGroupCell,
        isSelected: isSelected,
        startDate: startDate
      } = this.props;
      return createComponentVNode(2, DateTableCellBase, {
        className: `${ALL_DAY_PANEL_CELL_CLASS} ${className}`,
        viewContext: viewContext,
        startDate: startDate,
        endDate: endDate,
        groups: groups,
        groupIndex: groupIndex,
        allDay: true,
        isFirstGroupCell: isFirstGroupCell,
        isLastGroupCell: isLastGroupCell,
        index: index,
        dataCellTemplate: dataCellTemplate,
        isSelected: isSelected,
        isFocused: isFocused
      });
    }
  }
  AllDayPanelCell.defaultProps = DateTableCallBaseDefaultProps;
  return AllDayPanelCell;
})();